import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '@app/core/services/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DocumentViewerService } from '@app/shared/services/document-viewer.service';

export interface AccessorialDocumentItem {
  key?: string;
  name: string;
  signedUrl: string;
  updatedOn?: string;
  updatedAt?: string;
  createdOn?: string;
  createdAt?: string;
  LastModified?: string;
  lastModified?: string;
}

@Component({
  selector: 'app-accessorial-documents-modal',
  templateUrl: './accessorial-documents-modal.component.html',
  styleUrls: ['./accessorial-documents-modal.component.scss']
})
export class AccessorialDocumentsModalComponent {
  documents: AccessorialDocumentItem[] = [];

  constructor(
    private dialogRef: MatDialogRef<AccessorialDocumentsModalComponent>,
    private documentViewer: DocumentViewerService,
    private _commonService: CommonService,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: { documents: AccessorialDocumentItem[] }
  ) {
    this.documents = Array.isArray(data?.documents) ? data.documents : [];
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onViewDocument(doc: AccessorialDocumentItem): void {
    const documentKey = this.getDocumentKey(doc);
    if (!documentKey) {
      this._commonService.showSnakeBar('Document not available');
      return;
    }
    this.documentViewer.openKey(documentKey, doc?.name || 'Accessorial Document');
  }

  onDownloadDocument(doc: AccessorialDocumentItem): void {
    const documentKey = this.getDocumentKey(doc);
    if (!documentKey) {
      this._commonService.showSnakeBar('Document not available');
      return;
    }
    this.http.get(`master/document?key=${encodeURIComponent(documentKey)}&disposition=attachment`, this.getBlobRequestOptions())
      .subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = doc?.name || documentKey.split('/').pop() || 'document';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  }

  getDisplayUploadedOn(doc: AccessorialDocumentItem): string {
    const rawDate = doc?.updatedOn || doc?.updatedAt || doc?.LastModified || doc?.lastModified || doc?.createdOn || doc?.createdAt;
    if (!rawDate || rawDate === '-') {
      return '--';
    }
    const formatted = this._commonService.dtFormate(rawDate);
    return formatted && String(formatted).toLowerCase() !== 'invalid date' ? formatted : '--';
  }

  private getBlobRequestOptions() {
    return {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream'
      })
    };
  }

  private getDocumentKey(doc: AccessorialDocumentItem): string {
    return this.documentViewer.normalizeDocumentKey(doc?.key || doc?.signedUrl || '');
  }
}
